// https://www.figma.com/file/01KWBdMZg5QM9SRS1pQq0z/Design-System----Robot-Styles?type=design&node-id=96-1210&mode=design&t=e8gsezGHcqe627pt-0
// Breakpoints are the min value of the range for each size

export const SMALL_BREAKPOINT = 0; // 0px to 767px
export const MEDIUM_BREAKPOINT = 768; // 768px to 1024px
export const LARGE_BREAKPOINT = 1025; // 1025px and up
